//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoTreeviewBasic from './demos/DemoTreeviewBasic.vue'
import DemoTreeviewActivatable from './demos/DemoTreeviewActivatable.vue'
import DemoTreeviewColor from './demos/DemoTreeviewColor.vue'
import DemoTreeviewDenseMode from './demos/DemoTreeviewDenseMode.vue'
import DemoTreeviewHoverable from './demos/DemoTreeviewHoverable.vue'
import DemoTreeviewItemDisabled from './demos/DemoTreeviewItemDisabled.vue'
import DemoTreeviewLoadChildren from './demos/DemoTreeviewLoadChildren.vue'
import DemoTreeviewOpenAll from './demos/DemoTreeviewOpenAll.vue'
import DemoTreeviewRounded from './demos/DemoTreeviewRounded.vue'
import DemoTreeviewSelectable from './demos/DemoTreeviewSelectable.vue'
import DemoTreeviewSelectedColor from './demos/DemoTreeviewSelectedColor.vue'
import DemoTreeviewSelectionType from './demos/DemoTreeviewSelectionType.vue'
import DemoTreeviewShaped from './demos/DemoTreeviewShaped.vue'
import DemoTreeviewAppendAndLabel from './demos/DemoTreeviewAppendAndLabel.vue'
import DemoTreeviewSearchAndFilter from './demos/DemoTreeviewSearchAndFilter.vue'
import DemoTreeviewSelectableIcons from './demos/DemoTreeviewSelectableIcons.vue'

// code
import {
  treeviewBasic,
  treeviewActivatable,
  treeviewColor,
  treeviewDenseMode,
  treeviewHoverable,
  treeviewItemDisabled,
  treeviewLoadChildren,
  treeviewOpenAll,
  treeviewRounded,
  treeviewSelectable,
  treeviewSelectedColor,
  treeviewSelectionType,
  treeviewShaped,
  treeviewAppendAndLabel,
  treeviewSearchAndFilter,
  treeviewSelectableIcons,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoTreeviewBasic,
    DemoTreeviewActivatable,
    DemoTreeviewColor,
    DemoTreeviewDenseMode,
    DemoTreeviewHoverable,
    DemoTreeviewItemDisabled,
    DemoTreeviewLoadChildren,
    DemoTreeviewOpenAll,
    DemoTreeviewRounded,
    DemoTreeviewSelectable,
    DemoTreeviewSelectedColor,
    DemoTreeviewSelectionType,
    DemoTreeviewShaped,
    DemoTreeviewAppendAndLabel,
    DemoTreeviewSearchAndFilter,
    DemoTreeviewSelectableIcons,
  },
  setup() {
    return {
      codeSnippets: {
        treeviewBasic,
        treeviewActivatable,
        treeviewColor,
        treeviewDenseMode,
        treeviewHoverable,
        treeviewItemDisabled,
        treeviewLoadChildren,
        treeviewOpenAll,
        treeviewRounded,
        treeviewSelectable,
        treeviewSelectedColor,
        treeviewSelectionType,
        treeviewShaped,
        treeviewAppendAndLabel,
        treeviewSearchAndFilter,
        treeviewSelectableIcons,
      },
    }
  },
}
